'use client';

import React, { ComponentPropsWithRef } from 'react';
import * as Dialog from '@radix-ui/react-dialog';

export const Modal = ({ children, ...props }: ComponentPropsWithRef<typeof Dialog.Root>) => (
  <Dialog.Root {...props}>{children}</Dialog.Root>
);

Modal.displayName = 'Modal';

export const ModalTrigger = React.forwardRef<HTMLButtonElement, ComponentPropsWithRef<typeof Dialog.Trigger>>(
  ({ children, ...props }, ref) => (
    <Dialog.Trigger {...props} ref={ref}>{children}</Dialog.Trigger>
  )
);

ModalTrigger.displayName = 'ModalTrigger';

export const ModalContent = React.forwardRef<HTMLDivElement, ComponentPropsWithRef<typeof Dialog.Content>>(
  ({ children, className, ...rest }, ref) => (
    <Dialog.Portal>
      <Dialog.Overlay className="fixed inset-0 z-[999] bg-black/50 animate-overlayShow" />
      <Dialog.Content
        ref={ref}
        className={`animate-modalShow bg-white rounded-md shadow fixed top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 z-[1000] ${className}`}
        {...rest}
      >
        {children}
      </Dialog.Content>
    </Dialog.Portal>
  )
);

ModalContent.displayName = 'ModalContent';

export const ModalClose = React.forwardRef<HTMLButtonElement, ComponentPropsWithRef<typeof Dialog.Close>>(
  ({ children, ...rest }, ref) => (
    <Dialog.Close ref={ref} {...rest}>
      {children}
    </Dialog.Close>
  )
);

ModalClose.displayName = 'ModalClose';

export const ModalTitle = React.forwardRef<HTMLDivElement, ComponentPropsWithRef<typeof Dialog.Title>>(
  ({ children, ...rest }, ref) => (
    <Dialog.Title ref={ref} {...rest}>
      {children}
    </Dialog.Title>
  )
);

ModalTitle.displayName = 'ModalTitle';
